export default __webpack_public_path__ + "static/home-banner-d59c20e04770a7347428702ceee55c26.png";